import React, { Component } from 'react'
import { Col, Row, Form, Button, Spinner } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import { revenuecostService } from '../../../../Services/revenuecostService';
import Currency from '../../../../Function/currency.json'
import helperFunction from '../../../../Function/helperFunction';

export default class EditCost extends Component {
    state = {
        buttonSubmit: true,
        costItems: this.props.costItem,
        costObj: this.props.costItem[0],
        vendors: this.props.vendorList,
    }

    handleInputChange(e, index = "") {
        const { name, value } = e.target
        let rObj = this.state.costObj
        let cArray = this.state.costItems

        if (index !== "") {
            cArray[index][name] = value;
            if (name === 'item_name') {
                cArray[index]['description'] = value;
            }

            if (name === 'rate_per_qty') {
                let exrate = cArray[index].ex_rate
                let vat = cArray[index].vat
                let vatPer = (vat === "5" || vat === 5) ? 5 : 0
                let lcAmt = Number((exrate * value).toFixed(2))
                let vatAmt = 0;
                if (vatPer !== 0) {
                    vatAmt = ((lcAmt * vatPer) / 100).toFixed(2)
                    rObj.vat_amount = vatAmt
                    cArray[index]["vat_amount"] = vatAmt;
                } else {
                    rObj.vat_amount = vatAmt
                    cArray[index]["vat_amount"] = vatAmt;

                }
                rObj.lc_amount = lcAmt
                rObj.glc_amount = Number(lcAmt) + Number(cArray[index].vat_amount)

                cArray[index]["lc_amount"] = lcAmt;
                cArray[index]["glc_amount"] = Number(lcAmt) + Number(rObj.vat_amount);
            }

            if (name === 'ex_rate') {
                let rpq = cArray[index].rate_per_qty
                let vat = cArray[index].vat
                let vatPer = vat === "5" ? 5 : 0
                let lcAmt = Number((rpq * value).toFixed(2))
                let vatAmt = 0

                if (vatPer !== 0) {
                    vatAmt = ((lcAmt * vatPer) / 100).toFixed(2)
                    // cArray[index].vat_amount = vatAmt
                }
                //  let vatAmt = (lcAmt * vat) / 100 //remove comment getting error10-02-23

                rObj.vat_amount = vatAmt
                rObj.lc_amount = lcAmt
                rObj.ex_rate = value
                rObj.glc_amount = Number(lcAmt) + Number(vatAmt)

                cArray[index]["lc_amount"] = lcAmt;
                cArray[index]["glc_amount"] = Number(lcAmt) + Number(vatAmt);
                cArray[index]["vat_amount"] = vatAmt;
            }

            if (name === 'vat' && value !== 0) {
                let lcAmt = rObj.lc_amount
                let vatPer = value === "5" ? 5 : 0
                let gcAmtPercent = 0;
                if (vatPer === 0) {
                    gcAmtPercent = 0
                } else {
                    gcAmtPercent = ((lcAmt * vatPer) / 100).toFixed(2);
                }
                let gcAmt = Number(gcAmtPercent) + Number(lcAmt)
                rObj.glc_amount = gcAmt
                rObj.vat_amount = Number(gcAmtPercent)

                // cArray[index]["vat"] = value; //code apply by s  
                cArray[index]["glc_amount"] = gcAmt;
                cArray[index]["vat_amount"] = Number(gcAmtPercent);
            }

        } else {
            rObj[name] = value;
        }
        this.setState({ costObj: rObj, costItems: cArray })
    }

    handleSubmit = () => {
        this.setState({ buttonSubmit: false })
        let postData = JSON.parse(JSON.stringify(this.state.costItems[0]));
        delete postData.bill_data
        postData.job_id = this.props.jobId
        postData.job_token = this.props.jobToken;
        postData.customer_email = this.props.customerData.email
        postData.gross_amount = postData.glc_amount
        postData.remark = this.state.costObj.remark
        let qb = postData.qbook_vendor.split("_")
        postData.qbook_vendor = qb.length && qb[0]
        postData.qbook_vendor_name = qb.length && qb[1]
        postData.id = postData._id
        if(this.state.costObj.created_date) postData.created_date = this.state.costObj.created_date

        // let vatPer = (postData.vat === "5" || postData.vat === 5) ? 5 : 0
        // postData.vat = vatPer;
        if(this.state.costItems[0] && this.state.costItems[0]?.bill_data && this.state.costItems[0].draft===false){
            postData.draft = false
            postData.qid = this.state.costItems[0].bill_data.Bill.Id
            postData.syncToken = this.state.costItems[0].bill_data?.Bill?.SyncToken
            postData.syncToken = String(Number(postData.syncToken)+1)
            postData.currency_name = Currency.find((itm)=> itm.cc===postData.currency)?.name
            revenuecostService.billUpdateQB(postData).then(result => {
                if(result.status){
                    postData.bill_data = { ...result.data }
                    postData.draft = false
                    this.editCost(postData)
                }else{
                    toast.error("error")
                }
            })
        }else{
            this.editCost(postData)
        }
    }

    editCost = (postData) => {
        revenuecostService.updateCostStatus(postData).then(result => {
            if (result.status === true) {
                this.props.handleShowEditCost(false)
                this.setState({ buttonSubmit: true })
                toast.success(result.message);
                this.props.getCosts()
                this.props.profitNLoss()
            }else{
                this.setState({ buttonSubmit: true })
            }
        })
    }

    render() {
        const { costItems,vendors, buttonSubmit } = this.state
        // const { invoiceItem, quoteToken, jobId, carrierData, receiverData } = this.props
        // console.log(this.state,"costObj")

        return (
            <Form>
              {
                            costItems && costItems.length > 0 && costItems.map((item, key) => {
                                return (
                                    <Row className='customNoLineBreak' key={key}>
                                        <Col xs={3}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Select Job Item</Form.Label>
                                                <Form.Select name="item_name" value={item.item_name} onChange={(e) => this.handleInputChange(e, key)} >
                                                    <option value="">Select</option>
                                                    <option value="AIR FREIGHT CHARGES">AIR FREIGHT CHARGES</option>
                                                    <option value="SEA FREIGHT CHARGES">SEA FREIGHT CHARGES</option>
                                                    <option value="LAND FREIGHT CHARGES">LAND FREIGHT CHARGES</option>
                                                    <option value="COURIER CHARGES">COURIER CHARGES</option>
                                                    <option value="LOCAL TRANSPORTATION">LOCAL TRANSPORTATION</option>
                                                    <option value="PACKING CHARGES">PACKING CHARGES</option>
                                                    <option value="INSURANCE PREMIUM">INSURANCE PREMIUM</option>
                                                    <option value="STORAGES CHARGES">STORAGES CHARGES</option>
                                                    <option value="OTHER SERVICES">OTHER SERVICES</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={3}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Description</Form.Label>
                                                <Form.Control
                                                    name="description"
                                                    value={item.description}
                                                    onChange={(e) => this.handleInputChange(e, key)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={3}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Acc Type</Form.Label>
                                                <Form.Select aria-label="Default select example" name="type" onChange={(e) => this.handleInputChange(e, key)} value={item.type}>
                                                    <option>Select Type</option>
                                                    <option value="customer">Customer</option>
                                                    <option value="service_partner">Service Partner</option>
                                                    <option value="vendor">Vendor</option>
                                                    <option value="cash">Cash</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                        <Col xs={3}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>ACC NAME</Form.Label>
                                                <Form.Select aria-label="Vendors list" name="qbook_vendor" onChange={(e) => this.handleInputChange(e, key)} value={item.qbook_vendor}>
                                                    <option>Select Vendor</option>
                                                    {vendors.length && vendors.map(item => {
                                                        return <option value={`${item.quickBookRef.userid}_${item.business_name}`}>{item.business_name}</option>
                                                    })}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={2}>
                                            <Form.Group className="mb-3" >
                                                <Form.Label>Invoice NO.</Form.Label>
                                                <Form.Control
                                                    name="invoice_number"
                                                    value={item.invoice_number}
                                                    onChange={(e) => this.handleInputChange(e, key)}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <div className='px-2' style={{ maxWidth: 100 }}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Currency </Form.Label>
                                                <Form.Select name="currency" onChange={(e) => this.handleInputChange(e, key)} value={item.currency}>
                                                    <option>Currency</option>

                                                    {Currency.map(item => {
                                                        return <option value={item.cc}>{item.cc}
                                                            {/* ({item.symbol}) */}
                                                        </option>
                                                    })}
                                                </Form.Select>
                                            </Form.Group>
                                        </div>
                                        <div className='px-2' style={{ maxWidth: 90 }}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>FC Amount</Form.Label>
                                                <Form.Control
                                                    name="rate_per_qty"
                                                    value={item.rate_per_qty}
                                                    onChange={(e) => this.handleInputChange(e, key)}
                                                />
                                            </Form.Group>
                                        </div>

                                        <div className='px-2' style={{ maxWidth: 90 }}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ex Rate</Form.Label>
                                                <Form.Control
                                                    name="ex_rate"
                                                    value={item.ex_rate}
                                                    onChange={(e) => this.handleInputChange(e, key)}
                                                />
                                            </Form.Group>
                                        </div>

                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label>LC Amount</Form.Label>
                                                <Form.Control
                                                    name="lc_amount"
                                                    value={item.lc_amount}
                                                    onChange={(e) => this.handleInputChange(e, key)}
                                                    readOnly
                                                />
                                            </Form.Group>
                                        </Col>

                                        <div className='px-2' style={{ maxWidth: 150 }}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Vat</Form.Label>
                                                <Form.Select name="vat" onChange={(e) => this.handleInputChange(e, key)} value={item.vat}>
                                                    {/* <option value={0}>Zero-Rated</option>
                                                    <option value={5}>Exempt From VAT</option>
                                                    <option value={10}>SR Standard Rated (DXB) SS-DXB</option> */}
                                                    <option value={2}>Zero-Rated</option>
                                                    <option value={4}>Exempt From VAT</option>
                                                    <option value={5}>SR Standard Rated</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </div>

                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Vat Amount</Form.Label>
                                                <Form.Control
                                                    name="vat_amount"
                                                    value={item.vat_amount}
                                                    onChange={(e) => this.handleInputChange(e, key)}
                                                    readOnly
                                                />
                                            </Form.Group>
                                        </Col>
                                        {/* <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Date</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="created_date"
                                                    value={item.created_date.slice(0,10)}
                                                    onChange={(e) => this.handleInputChange(e, key)}
                                                />
                                            </Form.Group>
                                        </Col> */}

                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Gross LC Amount</Form.Label>
                                                <Form.Control
                                                    name="glc_amount"
                                                    value={item.glc_amount}
                                                    onChange={(e) => this.handleInputChange(e, key)}
                                                    readOnly
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )
                            })
                        }
                          <Row>
                    {buttonSubmit && <Button onClick={() => this.handleSubmit()}>Save</Button>}
                    {!buttonSubmit
                        && <Button variant="primary" disabled>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Loading...
                        </Button>
                    }
                </Row>
            </Form>
        )
    }
}
